import { render, staticRenderFns } from "./DxProductsMonthlyTable.vue?vue&type=template&id=7543a93c&"
import script from "./DxProductsMonthlyTable.vue?vue&type=script&lang=js&"
export * from "./DxProductsMonthlyTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports